<template>
  <v-dialog
    v-model="dialog"
    width="448"
    open-on-focus
    no-click-animation
    persistent
    content-class="new-message-dialog"
    @click:outside="onClickOutside"
    @keydown="onKeydown"
  >
    <v-card elevation="0">
      <v-form ref="form" class="new-message-form" @submit.prevent="onSubmit">
        <div class="new-message-form-body">
          <v-toolbar flat height="76">
            <v-toolbar-title class="new-message-toolbar-title"
              >{{
                readonly
                  ? 'View'
                  : editType === 'DUPLICATE'
                  ? 'Duplicate'
                  : 'Edit'
              }}
              message definition</v-toolbar-title
            >
            <v-spacer></v-spacer>
            <v-btn color="accent" icon tile @click="closeDialog">
              <v-icon size="24">mdi-close</v-icon>
            </v-btn>
          </v-toolbar>
          <!-- message -->
          <v-container class="new-message-card-container">
            <v-row>
              <v-col sm="12">
                <dialog-input
                  label="Message"
                  name="message"
                  :textarea="true"
                  :textareaExpandable="true"
                  :readonly="readonly || allowChangeOnlyDateTime"
                  :value="newMessageData.message"
                  @input="onInput"
                />
              </v-col>
            </v-row>
          </v-container>
          <v-container
            :class="
              `new-message-card-container ${
                !allowChangeOnlyDateTime ? 'py-0' : ''
              }`
            "
          >
            <v-row>
              <v-col sm="12">
                <time-picker
                  :readonly="readonly"
                  :initial-time="newMessageData.time"
                  :is-submit="messageScheduled"
                  @input="onInput"
                />
              </v-col>
            </v-row>
          </v-container>
          <v-container class="new-message-card-container py-0">
            <v-row v-if="!allowChangeOnlyDateTime">
              <v-col sm="6">
                <dialog-date-picker
                  label="From"
                  name="from"
                  :value="newMessageData.from"
                  :readonly="readonly"
                  :initial-date="newMessageData.from"
                  @input="onInput"
                />
              </v-col>
              <v-col sm="6">
                <dialog-date-picker
                  label="To"
                  name="to"
                  :value="newMessageData.to"
                  :readonly="readonly"
                  :initial-date="newMessageData.to"
                  :key="toKey"
                  @input="onInput"
                />
              </v-col>
            </v-row>
            <v-row v-else>
              <v-col sm="12">
                <dialog-date-picker
                  label="Date"
                  name="date"
                  :value="newMessageData.date"
                  :readonly="readonly"
                  :initial-date="newMessageData.date"
                  :minDate="$moment().format('YYYY-MM-DD')"
                  :key="dateKey"
                  @input="onInput"
                />
              </v-col>
            </v-row>
          </v-container>
          <v-container
            class="new-message-card-container py-0"
            v-if="
              (newMessageData.senderFirstName ||
                newMessageData.senderLastName) &&
                !allowChangeOnlyDateTime
            "
          >
            <v-row>
              <v-col sm="12">
                <p class="dialog-checkbox-label my-2">Sender</p>
                <p class="ml-3">
                  {{ newMessageData.senderFirstName }}
                  {{ newMessageData.senderLastName }}
                </p>
              </v-col>
            </v-row>
          </v-container>
          <v-container class="new-message-card-container py-0">
            <v-row>
              <v-col sm="12">
                <thumbnail-picker
                  v-if="!readonly || currentFile || currentMobileStaticMedia"
                  label="Thumbnail"
                  :current-file="currentFile"
                  :current-mobile-static-media="currentMobileStaticMedia"
                  @thumbnail-picked="setThumbnail"
                  :allowed-file-types="[17, 18, 19, 20, 21, 22, 23, 52]"
                  :readonly="readonly || allowChangeOnlyDateTime"
                  one-source-only
                  enable-mobile-static-media
                />
              </v-col>
            </v-row>
          </v-container>
          <v-container class="new-message-card-container py-0">
            <v-row>
              <v-col sm="12">
                <dialog-checkbox
                  label="Is this message definition related to target date?"
                  name="isProcedureDateRelated"
                  :readonly="readonly || allowChangeOnlyDateTime"
                  :value="newMessageData.isProcedureDateRelated"
                  :option="{
                    label: 'Yes',
                    value: newMessageData.isProcedureDateRelated,
                  }"
                  @input="onInput"
                />
              </v-col>
            </v-row>
          </v-container>
          <v-container class="new-message-card-container py-0 d-none">
            <v-row>
              <v-col sm="12">
                <dialog-checkbox
                  v-if="newMessageData.daysOfWeek"
                  label="Choose days on which messages will be sent:"
                  name="daysOfWeek"
                  :value="newMessageData.daysOfWeek"
                  :options="[
                    {
                      label: 'Monday',
                      value: newMessageData.daysOfWeek.monday,
                    },
                    {
                      label: 'Tuesday',
                      value: newMessageData.daysOfWeek.tuesday,
                    },
                    {
                      label: 'Wednesday',
                      value: newMessageData.daysOfWeek.wednesday,
                    },
                    {
                      label: 'Thursday',
                      value: newMessageData.daysOfWeek.thursday,
                    },
                    {
                      label: 'Friday',
                      value: newMessageData.daysOfWeek.friday,
                    },
                    {
                      label: 'Saturday',
                      value: newMessageData.daysOfWeek.saturday,
                    },
                    {
                      label: 'Sunday',
                      value: newMessageData.daysOfWeek.sunday,
                    },
                  ]"
                  @input="onInput"
                />
              </v-col>
            </v-row>
          </v-container>
          <v-container class="new-message-card-footer d-flex justify-end">
            <v-btn
              rounded
              outlined
              color="accent"
              elevation="0"
              v-if="!readonly && !allowChangeOnlyDateTime"
              @click="onDelete"
            >
              {{
                newMessageData.from == newMessageData.to
                  ? 'Delete'
                  : 'Delete all'
              }}
            </v-btn>
            <v-btn
              v-if="
                newMessageData.correlationId &&
                  !readonly &&
                  !allowChangeOnlyDateTime
              "
              rounded
              outlined
              color="accent"
              elevation="0"
              class="template-delete"
              @click="onDeleteTemplate"
            >
              Sprint delete
            </v-btn>
            <v-spacer />
            <v-btn
              :disabled="!formIsValidCheck || readonly"
              rounded
              color="primary"
              type="submit"
              elevation="0"
            >
              {{ editType === 'DUPLICATE' ? 'Duplicate' : 'Save' }}
            </v-btn>
          </v-container>
        </div>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
import DialogCheckbox from '@/components/forms/DialogCheckbox.vue'
import DialogInput from '@/components/forms/DialogInput.vue'
// import DialogTimePicker from '@/components/forms/DialogTimePicker.vue'
import DialogDatePicker from '@/components/forms/DialogDatePicker.vue'
import TimePicker from '@/components/forms/TimePicker.vue'
import ThumbnailPicker from '@/components/inputs/ThumbnailPicker.vue'
import StaticMediaMixin from '@/mixins/staticMedia'

const emptyForm = {
  message: null,
  time: null,
  from: null,
  to: null,
  date: null,
  daysOfWeek: {
    monday: true,
    tuesday: true,
    wednesday: true,
    thursday: true,
    friday: true,
    saturday: true,
    sunday: true,
  },
  isProcedureDateRelated: false,
}

export default {
  name: 'EditMessageDialog',
  mixins: [StaticMediaMixin],
  components: {
    DialogInput,
    DialogCheckbox,
    // DialogTimePicker,
    DialogDatePicker,
    TimePicker,
    ThumbnailPicker,
  },
  props: {
    participantId: {
      type: Array,
      default: () => [],
    },
    participantTz: {
      type: String,
      default: 'Europe/Warsaw',
    },
    showDialog: {
      type: Boolean,
      default: false,
    },
    messageDefinition: {
      type: [Boolean, Object],
      default: false,
    },
    messageDefinitionResource: {
      type: [Boolean, Object],
      default: false,
    },
    resource: {
      type: [Boolean, Object],
      default: false,
    },
    getResource: {
      type: Function,
      default: () => null,
    },
    reloadImageResource: {
      type: Function,
      default: () => null,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    allowChangeOnlyDateTime: {
      type: Boolean,
      default: false,
    },
    editType: {
      type: [String],
      validator(val) {
        return ['EDIT', 'DUPLICATE'].includes(val)
      },
      default: 'EDIT',
    },
  },
  data() {
    return {
      dialog: false,
      rules: {
        text: [v => !!v || 'Value cannot by empty'],
      },
      resourceName: null,
      formIsValidCheck: false,
      toKey: 0,
      dateKey: 0,
      messageScheduled: false,
      thumbnailUrl: null,
      mediaUrl: null,
      thumbnailValue: null,
      mediaFileTypeId: null,
    }
  },
  watch: {
    showDialog: function(val) {
      if (val) {
        this.dialog = true
      } else {
        this.dialog = false
      }
    },
    messageDefinition: {
      handler: function(val) {
        if (val) {
          // Reset internal state when message definition changes
          this.thumbnailValue = null
          this.messageScheduled = false
          this.dateKey++
          this.formIsValid()
        }
      },
      deep: true,
    },
    messageDefinitionResource: {
      handler: function(val) {
        this.thumbnailUrl = val?.thumbnailUrl || val?.previewUrl
        null
        this.mediaUrl = val?.fileUrl || val?.mediaUrl || null
        this.mediaFileTypeId = val?.fileTypeId || null
      },
      deep: true,
    },
  },
  mounted() {
    this.formIsValid()
  },
  computed: {
    newMessageData() {
      return Object.assign({}, emptyForm, this.messageDefinition)
    },
    currentFile() {
      if (!this.thumbnailUrl && !this.mediaUrl) {
        return null
      }

      return {
        fileTypeId: this.mediaFileTypeId,
        thumbnailUrl: this.thumbnailUrl,
        mediaUrl: this.mediaUrl || null,
      }
    },
    currentMobileStaticMedia() {
      const staticMediaId = this.editedMessage?.staticMediaId
      if (!staticMediaId || !this.staticMedia) return null

      const selectedStaticMedia = this.staticMedia.find(
        el => el.id === staticMediaId,
      )
      if (!selectedStaticMedia) {
        return null
      }

      return {
        mediaUrl: selectedStaticMedia.mediaUrl,
      }
    },
  },
  methods: {
    setThumbnail(thumbnail = null) {
      this.formIsValid()
      if (thumbnail === null) {
        // remove
        this.thumbnailValue = { remove: true }
        this.editedMessage.staticMediaId = null
      } else {
        const { type, file } = thumbnail

        if (type === 'media-library') {
          this.thumbnailValue = { mlSourceResourceId: file.id }
        } else if (type === 'file-picker') {
          this.thumbnailUrl = null
          this.mediaUrl = null
          this.thumbnailValue = file
        } else if (type === 'mobile-static-media') {
          this.thumbnailUrl = null
          this.mediaUrl = null
          this.thumbnailValue = { staticMediaId: file.id }
        }
      }
    },
    async openBigImage({ url, file, name, mlResourceUrl, type }) {
      if (this.messageDefinitionResource.id) {
        this.$emit('show-bigger-image', {
          url: null,
          file: null,
          name: null,
          mlResourceUrl: null,
        }) // Show dialog while getting new s3 file url
        await this.reloadImageResource(this.messageDefinitionResource.id)
      }
      const title =
        this.messageDefinitionResource.title.replace(/[/\\?%*:|"<>]/g, '-') +
        '.' +
        this.messageDefinitionResource.name
          .split('.')
          .pop()
          .trim()
          .toLowerCase()
      this.$emit('show-bigger-image', {
        url: this.messageDefinitionResource.fileUrl,
        name: title || this.resourceName,
        file: this.messageDefinitionResource.previewUrl,
        mlResourceUrl: this.messageDefinitionResource.id,
      })
    },
    formIsValid() {
      const baseValidation =
        this.newMessageData.message &&
        this.newMessageData.message.trim() !== '' &&
        this.newMessageData.time &&
        this.newMessageData.to &&
        this.newMessageData.from &&
        this.$moment(this.newMessageData.from) <=
          this.$moment(this.newMessageData.to)

      if (this.allowChangeOnlyDateTime) {
        const futureValidation =
          this.$moment(
            this.newMessageData.date + ' ' + this.newMessageData.time,
          ).diff(this.$moment(this.getParticipantTime()).format(), 'HH') > 0

        this.formIsValidCheck = baseValidation && futureValidation
      } else {
        const timeValidation =
          this.$moment(
            this.newMessageData.from + ' ' + this.newMessageData.time,
          ).diff(this.$moment(this.getParticipantTime()).format(), 'HH') > 0

        this.formIsValidCheck = baseValidation && timeValidation
      }
    },
    getParticipantTime() {
      const currentTime = new Date().getTime()
      const currentDateFormat = this.$moment(currentTime).format(
        'YYYY-MM-DD HH:mm:ss',
      )
      const patientDateFormat = this.$moment(currentTime)
        .tz(this.participantTz)
        .format('YYYY-MM-DD HH:mm:ss')
      const calculateDiff = this.$moment(patientDateFormat).diff(
        this.$moment(currentDateFormat),
      )

      return new Date(currentTime + calculateDiff).getTime()
    },
    closeDialog() {
      this.dialog = false
      this.$emit('close-message-dialog')
    },
    onClickOutside() {
      this.closeDialog()
    },
    onKeydown(key) {
      if (key.code === 'Escape' && key.isTrusted) this.closeDialog()
    },
    onInput({ name, value }) {
      if (value && (name == 'from' || name == 'to')) {
        const selectedDate = this.$moment(value)

        this.newMessageData[name] = selectedDate.format('YYYY-MM-DD')
        if (name == 'from' && !this.allowChangeOnlyDateTime) {
          if (
            this.$moment(this.newMessageData['to']).isBefore(
              this.newMessageData['from'],
              'day',
            )
          ) {
            this.newMessageData['to'] = this.newMessageData['from']
            this.toKey++
          }
        }
      } else if (name == 'date' && this.allowChangeOnlyDateTime) {
        this.newMessageData[name] = value
        this.dateKey++
      } else if (name == 'daysOfWeek') {
        let tmp = {}
        value.forEach(el => {
          tmp[el.toLowerCase()] = true
        })
        this.newMessageData[name] = tmp
      } else this.newMessageData[name] = value
      this.formIsValid()
      this.$emit('on-change', {
        ...this.newMessageData,
        thumbnailValue:
          this.thumbnailValue?.mlSourceResourceId ||
          this.thumbnailValue?.remove ||
          this.thumbnailValue?.staticMediaId
            ? { ...this.thumbnailValue }
            : this.thumbnailValue,
      })
    },
    onChange(event) {
      this.newMessageData['Message'] = event
      this.formIsValid()
      this.$emit('on-change', {
        ...this.newMessageData,
        thumbnailValue:
          this.thumbnailValue?.mlSourceResourceId ||
          this.thumbnailValue?.remove ||
          this.thumbnailValue?.staticMediaId
            ? { ...this.thumbnailValue }
            : this.thumbnailValue,
      })
    },
    onSubmit() {
      this.messageScheduled = true
      this.$emit('on-submit', {
        ...this.newMessageData,
        thumbnailValue:
          this.thumbnailValue?.mlSourceResourceId ||
          this.thumbnailValue?.remove ||
          this.thumbnailValue?.staticMediaId
            ? { ...this.thumbnailValue }
            : this.thumbnailValue,
      })
      this.formIsValid()
      this.closeDialog()
    },
    onDelete() {
      this.closeDialog()
      this.formIsValid()
      this.$emit('on-delete', this.messageDefinition.id)
    },
    onDeleteTemplate() {
      this.closeDialog()
      this.formIsValid()
      this.$emit('on-delete-template', this.messageDefinition.correlationId)
    },
  },
}
</script>

<style lang="scss">
@import '@/styles/variables.scss';

.new-message {
  &-dialog {
    margin: $gutter;
    margin-left: auto;
    height: 100%;
    max-height: calc(100% - #{2 * $gutter}) !important;
    // looks little hacky
    > .v-card {
      width: 100%;
      height: 100%;
    }
  }
  &-toolbar-title {
    color: $bh-blue;
    font-size: 1.5715rem;
    font-weight: bold;
  }
  &-tabs {
    padding: 0 24px;
    background: #ffffff;
    .v-tab {
      color: $bh-blue;
      text-transform: none;
      letter-spacing: 0;
      font-size: 1em;
      &:not(.v-tab--active) {
        color: white;
      }
    }
    .v-tabs-slider {
      background: $bh-blue;
    }
  }
  &-v-tabs-items {
    background: $bh-blue--4 !important;
  }
  &-card {
    &-title {
      font-size: $font-size-root;
      color: $bh-gray--2;
      padding-left: 1.5 * $gutter;
      padding-right: 1.5 * $gutter;
    }
    &-container {
      padding-left: 1.5 * $gutter;
      padding-right: 1.5 * $gutter;
      padding-top: 16px;
      padding-bottom: 16px;
    }
    &-footer {
      padding: 1.5 * $gutter;
      .template-delete {
        margin-left: 10px;
      }
    }
  }
  &-file-button {
    margin-right: 10px;
    .v-icon {
      &:first-child {
        padding-right: 10px;
      }
      &:last-child {
        padding-left: 10px;
      }
    }
  }
  &-file-details {
    display: inline-block;
    img {
      width: 40px;
      height: 40px;
      display: inline-block;
      vertical-align: middle;
      object-fit: cover;
      margin-right: 10px;
      cursor: pointer;
    }
    .v-progress-circular {
      margin-right: 10px;
    }
    .v-icon {
      margin-left: 5px;
      padding: 4px;
    }
    span {
      cursor: default;
    }
  }
  &-form {
    background-color: $bh-blue--4;
    height: 100%;
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    overflow: auto;

    &-body {
      ::v-deep .v-toolbar__content {
        padding-left: 1.5 * $gutter;
        padding-right: 1.5 * $gutter;
      }
    }
    &-col-left {
      padding-top: 0;
      padding-right: 0.25 * $gutter;
    }
    &-col-right {
      padding-top: 0;
      padding-left: 0.25 * $gutter;
    }
  }
}
</style>
